export default {
  methods: {
    getBookType(code, short = false) {
      const num = parseInt(code)
      switch (num) {
        case 1987051001:
          return short ? '纸书' : '纸本图书'
        case 1987052001:
          return '外文书目'
        case 1987054001:
          return '中文书目'
        default:
          return ''
      }
    },
  },
}
